// import dynamic from "next/dynamic";
import React from "react";
import Page410 from "@/Components/410/410";
import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.statusCode = 410; // ✅ Sets the correct status code

  return {
    props: {}, // ✅ Next.js still requires props, even if empty
  };
};

const Custom404 = () => {
  return (
    <>
      <div className="middle-sction middle-pad">
        <Page410 />
      </div>
    </>
  );
};

export default Custom404;
